import React from 'react';
import css from 'styled-jsx/css';
import Banner from './Banner';
import Steps from './Steps';
import FAQ from './FAQ';
import Mobile from './Mobile/index';
import withI18next from '~/../hocs/_withI18next';
import themeVariables from '~/shared/themeVariables';
@withI18next(['page-sell-your-content'])
class SellYourContentPage extends React.Component {
  render() {
    const { t, lng } = this.props;
    return (
      <>
        <Mobile t={t} />
        <div className="sell-your-content-page">
          <Banner t={t} />
          <Steps
            t={t}
            style={{
              paddingTop: themeVariables.space.medium,
              paddingBottom: themeVariables.space.medium,
            }}
          />
          <FAQ
            t={t}
            lng={lng}
            style={{
              paddingTop: themeVariables.space.medium,
              paddingBottom: themeVariables.space.medium,
            }}
          />
          <style jsx>{styles}</style>
        </div>
      </>
    );
  }
}

const styles = css`
  .sell-your-content-page {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 80px;
  }
  @media screen and (min-width: 0px) and (max-width: 729px) {
    .sell-your-content-page {
      display: none;
    }
  }
`;

export default SellYourContentPage;
